module.exports = __webpack_public_path__ + "static/Resin Bonded Bridges intraoral before-4670c8237663d04c45d4d6b17c6ccf7b.jpg";